import { useTranslation } from 'react-i18next';

export default function ConnaitreQuartier() {
  const { t } = useTranslation('stjean');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-5 md:mb-6 leading-tight">
              {t('quartier_h2')}
            </h2>
            <p className="text-sm md:text-base text-[#4A5568] leading-relaxed mb-4">
              {t('quartier_p1')}
            </p>
            <p className="text-sm md:text-base text-[#4A5568] leading-relaxed">
              {t('quartier_p2')}
            </p>
          </div>

          <div className="rounded-lg overflow-hidden h-[320px] md:h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Mixed Quebec neighborhood with new family homes and older village houses, growing residential area, street with modern and traditional architecture, green trees, bright summer day, authentic suburban photography, warm earth tones with slate blue and copper accents on roofs"
              alt="Quartier mixte ancien et neuf à Saint-Jean-Chrysostome, Lévis"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              width="700"
              height="500"
            />
          </div>
        </div>
      </div>
    </section>
  );
}